module.exports = __webpack_public_path__ + "static/media/cyan-note-text.5af4606f.svg";